<template>
	<v-dialog v-model="enderecoDialog" max-width="400">
		<Card>
			<v-card-title class="pb-0 pl-0 pr-0 pt-0">
				<p class="descricaoItem ma-0 pa-0">Dados de endereço</p>
			</v-card-title>
			<v-container class="pt-0 pb-0">
				<v-progress-linear v-if="loading" indeterminate color="primary" />
				<v-row class="texto--text">
					<v-col sm="12" md="12" v-if="empresa.valorentrega > 0" class="pa-0 ma-0">
						<p class=" mb-0">Taxa de entrega: R${{ empresa.valorentrega.replace('.', ',') }}</p>
					</v-col>
				</v-row>
				<v-row>
					<v-col sm="12" md="12" class="pl-0 pr-0">
						<v-text-field
							v-model="cep"
							v-mask="'#####-###'"
							label="CEP"
							filled
							dense
							rounded
							hide-details
							@input="buscaCep()"
							class="textField pa-0"
						/>
					</v-col>
				</v-row>
				<v-row>
					<v-col sm="12" md="12" class="pl-0 pr-0 pt-0">
						<v-text-field
							v-model="logradouro"
							label="Rua/Logradouro"
							filled
							dense
							rounded
							hide-details
							class="textField pa-0"
						/>
					</v-col>
				</v-row>
				<v-row>
					<v-col sm="4" md="4" class="pl-0 pr-0 pt-0">
						<v-text-field
							v-model="numero"
							v-mask="'####'"
							label="Número"
							filled
							dense
							rounded
							hide-details
							class="textField pa-0"
						/>
					</v-col>
					<v-col class="pr-0 pt-0">
						<v-text-field
							v-model="bairro"
							label="Bairro"
							filled
							dense
							rounded
							hide-details
							class="textField pa-0"
						/>
					</v-col>
				</v-row>
				<v-row>
					<v-col sm="4" md="4" class="pr-0 pl-0 pt-0" >
						<v-text-field
							v-model="uf"
							v-mask="'AA'"
							label="UF"
							filled
							dense
							rounded
							hide-details
							class="textField pa-0"
						/>
					</v-col>
					<v-col sm="8" md="8" class="pr-0 pt-0">
						<v-text-field
							v-model="cidade"
							label="Cidade"
							filled
							dense
							rounded
							hide-details
							class="textField pa-0"
						/>
					</v-col>
				</v-row>
			</v-container>
			<template v-slot:acoes>
				<Botao transparente texto="Cancelar" @clicar="dialogEnderecoClose()" />
				<Botao color="success" texto="Confirmar" @clicar="salvarEndereco()" />
			</template>
		</Card>
	</v-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Card from '../shared/Card.vue'
import Botao from '../shared/Botao.vue'

export default {
	props: { dialogEndereco: Boolean },
	data: function () {
		return {
			loading: false,
			cep: '',
			logradouro: '',
			bairro: '',
			cidade: '',
			uf: '',
			complemento: '',
			numero: '',
			dialogDadosCompra: false,
		}
	},
	components: {
		Card,
		Botao
	},
	computed: {
		...mapGetters({ empresa: 'empresa', endereco: 'endereco' }),
		enderecoDialog: {
			get() {
				return this.dialogEndereco
			},
			set() {
				this.dialogEnderecoClose()
			},
		},
	},
	methods: {
		...mapActions({ addEndereco: 'addEndereco' }),
		click() {
			this.dialogEnderecoClose()
		},
		dialogEnderecoClose() {
			this.$emit('dialogEnderecoClose')
			this.limpaCampos()
		},
		loadEndereco() {
			if (this.endereco.cep) {
				this.cep = this.endereco.cep
				this.logradouro = this.endereco.logradouro
				this.bairro = this.endereco.bairro
				this.cidade = this.endereco.cidade
				this.uf = this.endereco.uf
				this.complemento = this.endereco.complemento
				this.numero = this.endereco.numero
			}
		},
		salvarEndereco() {
			if (this.validarCamposEndereco()) {
				const endereco = {
					entrega: 'Entrega',
					logradouro: this.logradouro,
					cep: this.cep,
					numero: this.numero,
					bairro: this.bairro,
					uf: this.uf,
					cidade: this.cidade,
					complemento: this.complemento,
				}
				this.addEndereco(endereco)
				this.dialogEnderecoClose()
				this.dialogDadosCompraOpen()
			}
		},
		validarCamposEndereco() {
			let valido = false
			if (!this.cep) {
				this.$store.dispatch('showError', 'É necessário informar o CEP!')
				return valido
			}
			if (!this.logradouro) {
				this.$store.dispatch('showError', 'É necessário informar o logradouro!')
				return valido
			}
			if (!this.numero) {
				this.$store.dispatch('showError', 'É necessário informar a número!')
				return valido
			}
			if (!this.bairro) {
				this.$store.dispatch('showError', 'É necessário informar o bairro!')
				return valido
			}
			if (!this.uf) {
				this.$store.dispatch('showError', 'É necessário informar a UF!')
				return valido
			}
			if (!this.cidade) {
				this.$store.dispatch('showError', 'É necessário informar a cidade!')
				return valido
			}

			valido = true
			return valido
		},
		limpaCampos() {
			this.logradouro = ''
			this.cep = ''
			this.numero = ''
			this.bairro = ''
			this.uf = ''
			this.cidade = ''
			this.complemento = ''
		},
		dialogDadosCompraOpen() {
			this.dialogDadosCompra = true
		},
		dialogDadosCompraClose() {
			this.dialogDadosCompra = false
		},
		async buscaCep() {
			try {
				if (this.cep.length > 8) {
					this.loading = true
					let cep = this.cep.replace('-', '').substring(0, 8)
					const ret = await this.axios.get(`https://viacep.com.br/ws/${cep}/json/`, { headers: null })

					if (ret.status == 200) {
						this.logradouro = ret.data.logradouro
						this.bairro = ret.data.bairro
						this.cidade = ret.data.localidade
						this.uf = ret.data.uf
					}
				}
			} catch (error) {
				//registra erro
			} finally {
				this.loading = false
			}
		},
	},
	watch: {
		dialogEndereco() {
			this.limpaCampos()
			this.loadEndereco()
		},
	},
}
</script>
<style scoped>
.descricaoItem {
	font-weight: bold;
	color: var(--v-primary-base);
}
.radioButton {
	font-weight: bold;
}
.textField {
	font-weight: 600;
	border-radius: 1rem;
}

.textField >>> .v-text-field__slot input {
    color: var(--v-texto-base);
}

</style>